import { IPCheckbox } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalStackTokensGapSmall } from 'globalStyles';
import { ReportRequest15DTO } from 'models/dto/Reports/ReportRequests_15_DTO';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IReportRequestOptions } from '../ReportRequest';

const ReportOptions15 = (props: IReportRequestOptions) => {
  const { t } = useTranslation(['translation', 'publication']);
  const [showMinorVersions, setShowMinorVersions] = useState<boolean>(false);

  const updateOptions = (showMinorVersions: boolean) => {
    const reportRequest = (props.reportRequest as ReportRequest15DTO).clone();
    reportRequest.showOldConceptVersions = showMinorVersions;
    props.onUpdate(reportRequest, true);
  };

  //
  // Main render
  //
  return (
    <IPStack tokens={globalStackTokensGapSmall}>
      <IPStack.Item>
        <IPCheckbox
          label={t('publication:Publish.PublicationHistoryModal.ShowMinorVersions')}
          checked={showMinorVersions}
          onChange={(ev, checked) => {
            setShowMinorVersions(checked ?? false);
            updateOptions(checked ?? false);
          }}
        />
      </IPStack.Item>
    </IPStack>
  );
};

export default ReportOptions15;
